import { TYPES } from '../../organizedByType/actions/adActions'

const INITIAL_STATE = {
  topAdHeight: 0,
}
export function topAdReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case TYPES.SLOT_RENDERED:
      return action.state.adId === 'Top'
        ? { ...state, topAdHeight: action.state.size.height }
        : state
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/topAd/topAd.reducers.js